import { useApp } from '../context.js';

export default function SearchBar() {
    const { activeRestaurantCount, searchQuery, setSearchQuery, sortedRestaurants } = useApp();
    return (
        <div className="bg-white/90 apple-card rounded-2xl p-3 shadow-md mb-4">
            <div className="relative">
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search restaurants..."
                    className="w-full px-4 py-3 pr-10 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-base"
                />
                {searchQuery && (
                    <button
                        onClick={() => setSearchQuery('')}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 apple-button"
                    >
                        ✕
                    </button>
                )}
            </div>
            {searchQuery && (
                <div className="mt-2 text-xs text-gray-600 text-center">
                    {sortedRestaurants.length} of {activeRestaurantCount} places
                </div>
            )}
        </div>
    );
}
